import { Component, OnInit } from '@angular/core'
import {
    EnvironmentService,
    CustomDateFormatsProvider,
    customLocalizedDateFormats,
    LangUrlInjector,
    ActiveLinkService
} from '@surgetech-eu/core'
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import { filter } from 'rxjs/operators'
import { TranslateService } from '@ngx-translate/core'

@Component({
    selector: 'app-root',
    template: '<surge-root></surge-root>',
    standalone: false
    //
})
export class AppComponent {
    favIcon: HTMLLinkElement = document.querySelector('#favIcon')

    constructor(
        private environment: EnvironmentService,
        private router: Router,
        private route: ActivatedRoute,
        private activeLinkService: ActiveLinkService, // needed to initialize service before first router events
        private translate: TranslateService,
        customDateFormatsProvider: CustomDateFormatsProvider,
        private _langUrlInjector: LangUrlInjector
    ) {
        this.tempTitleAndIconUpdate()

        router.events.pipe(filter(ev => ev instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            this.updateTitleAndIcon()
            const localeOverride = this.getLocaleOverride(this.route)
            const userLang = localeOverride || localStorage.getItem('lang') || 'en-GB'
            this.translate.use(userLang)
        })

        this.translate.addLangs(['en-GB', 'it-IT', 'zh-CN'])
        customDateFormatsProvider.setCustomFormats(customLocalizedDateFormats)
        this.translate.setDefaultLang('en-GB')
    }

    updateTitleAndIcon() {
        let customTitle
        let customFavicon

        // Traverse to the first active child route
        let currentRoute = this.route

        while (currentRoute) {
            const title = currentRoute.snapshot.data?.title
            const favicon = currentRoute.snapshot.data?.favicon
            if (title) {
                customTitle = title
            }
            if (favicon) {
                customFavicon = favicon
            }

            currentRoute = currentRoute.firstChild // Move to the first active child route
        }
        document.title = customTitle || this.environment.get().title
        this.favIcon.href = customFavicon || 'favicon.ico'
    }

    private tempTitleAndIconUpdate() {
        let customTitle
        let customFavicon

        const pathParts = document.URL.replace(document.baseURI, '').split('/')
        let routes = this.router.config
        for (let i = 0; i < pathParts.length && routes; i++) {
            const config = routes.find(route => route.path === pathParts[i])
            if (config) {
                if (config.data) {
                    if (config.data.title) {
                        customTitle = config.data.title
                    }
                    if (config.data.favicon) {
                        customFavicon = config.data.favicon
                    }
                }
            }
            routes = config?.children
        }

        document.title = customTitle || this.environment.get().title
        this.favIcon.href = customFavicon || 'favicon.ico'
    }

    getLocaleOverride(route) {
        if (!route) {
            return false
        }
        const forceLocale = route.routeConfig?.data?.forceLocale
        return forceLocale || this.getLocaleOverride(route.firstChild)
    }
}
